var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImagePlaceholderIcon = function SvgImagePlaceholderIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0H2.5C1.4 0 0.5 0.9 0.5 2V12C0.5 13.1 1.4 14 2.5 14H17.5C18.6 14 19.5 13.1 19.5 12V2C19.5 0.9 18.6 0 17.5 0ZM5.5 2C6.6 2 7.5 2.9 7.5 4C7.5 5.1 6.6 6 5.5 6C4.4 6 3.5 5.1 3.5 4C3.5 2.9 4.4 2 5.5 2ZM16.7 12.4H3.7C2.8 12.4 2.4 11.4 3 10.8L4.7 9.1C5.1 8.7 5.7 8.7 6.1 9.1L7.3 10.3C7.7 10.7 8.4 10.7 8.7 10.2L12.5 5.4C12.9 4.9 13.7 4.9 14 5.5L17.5 11C18 11.6 17.5 12.4 16.7 12.4Z",
    fill: "#9FB0B7"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImagePlaceholderIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "cc58cf0411c5c98441241fb5960aed43.svg";